// Audio configuration - centralized for easy updates
const AUDIO_BASE_URL = 'https://therisingschool.com/Learning%20Games/MP3';

export const AUDIO_CONFIG = {
  QUESTION_SOUND: `${AUDIO_BASE_URL}/Question.mp3`,
  TIMER_SOUND: `${AUDIO_BASE_URL}/Timer.mp3`,
  START_SOUND: `${AUDIO_BASE_URL}/Start.mp3`,
  CORRECT_SOUND: `${AUDIO_BASE_URL}/Question.mp3`,
  WRONG_SOUND: `${AUDIO_BASE_URL}/Timer.mp3`,
  LIFELINE_SOUND: `${AUDIO_BASE_URL}/Start.mp3`
};

// Alternative: Local fallback URLs (if needed)
export const LOCAL_AUDIO_CONFIG = {
  QUESTION_SOUND: '/uploads/Question.mp3',
  TIMER_SOUND: '/uploads/Timer.mp3',
  START_SOUND: '/uploads/Start.mp3',
  CORRECT_SOUND: '/uploads/Question.mp3',
  WRONG_SOUND: '/uploads/Timer.mp3',
  LIFELINE_SOUND: '/uploads/Start.mp3'
};

// Environment-based configuration
export const getAudioConfig = () => {
  // Use external URLs by default, fallback to local if needed
  const useExternal = process.env.REACT_APP_USE_EXTERNAL_AUDIO !== 'false';
  return useExternal ? AUDIO_CONFIG : LOCAL_AUDIO_CONFIG;
};

// Export default config
export default AUDIO_CONFIG;